<template>
    <li :class="{ panel_active: open }">
        <div class="brand-strengths__button-wrapper">
            <hr class="brand-strengths__horizontal-rule">
            <button @click="toggle" class="brand-strengths__button" type="button">
                <slot name="heading"/>
                <div class="brand_strengths_toggle-container">
                    <slot name="toggle_symbol"/>
                </div>
            </button>
            <transition-panel>
                <div v-show="open">
                    <div class="brand-strengths__item-copy" v-html="content"/>
                </div>
            </transition-panel>
        </div>
    </li>
</template>

<script>
import TransitionPanel from '@/components/TransitionPanel';

export default {
    name: 'BasePanel',
    components: {
        TransitionPanel,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isActive: undefined,
            accordion: undefined,
        };
    },
    computed: {
        open() {
            return this.accordion ? this === this.accordion.activePanel : this.isActive;
        },
    },
    methods: {
        toggle() {
            if (this.accordion) {
                this.accordion.$emit('set-active-panel', this.open ? null : this);
            } else {
                this.isActive = !this.isActive;
            }
        },
    },
    created() {
        let parent = this.$parent;

        while (parent) {
            if (parent.$options.name === 'BaseAccordian') {
                parent.$emit('add-panel', this);
                this.accordion = parent;
                this.isActive = null;

                return;
            }

            parent = parent.$parent;
        }

        this.accordion = null;
        this.isActive = this.active;
    },
};
</script>



// WEBPACK FOOTER //
// BasePanel.vue?f3f6c942